module.exports = __webpack_public_path__ + "static/media/Form.e9227053.jpg";